import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Footer from "../component/layout/footer";
import Header from "../component/layout/header";

import PopularPost from "../component/sidebar/popular-post";

const IMAGE_BASE_URL =
  "https://kalakakshaaha.com/uploads/blogs/";

const BlogDetails = () => {
  const { slug } = useParams(); // ✅ slug instead of id
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= FETCH BLOG BY SLUG ================= */
  useEffect(() => {
    fetch(
      `https://kalakakshaaha.com/kks/api/v1/blogs?slug=${slug}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setBlog(data.blog);
        else setError("Blog not found");
      })
      .catch(() => setError("Something went wrong"))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <Fragment>
      <Header />

      <div className="blog-section blog-single padding-tb section-bg">
        <div className="container" style={{ marginTop: "5%" }}>
          <div className="row justify-content-center">

            {/* ===== MAIN CONTENT ===== */}
            <div className="col-lg-8 col-12">
              {loading && <p>Loading blog...</p>}
              {error && <p className="text-danger">{error}</p>}

              {blog && (
                <article>
                  <div className="section-wrapper">
                    <div className="row row-cols-1 g-4">
                      <div className="col">
                        <div className="post-item style-2">
                          <div className="post-inner">

                            {/* IMAGE */}
                            <div className="post-thumbb">
                              <img
                                src={`${IMAGE_BASE_URL}${blog.image}`}
                                alt={blog.title}
                                className="w-100"
                                onError={(e) =>
                                  (e.target.src =
                                    "/assets/images/blog/single/01.jpg")
                                }
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>

                            {/* CONTENT */}
                            <div className="post-content">
                              <h2>{blog.title}</h2>

                              {/* META */}
                              <div className="meta-post">
                                <ul className="lab-ul">
                                  <li>
                                    <i className="icofont-calendar"></i>{" "}
                                    {new Date(
                                      blog.published_date
                                    ).toDateString()}
                                  </li>
                                  <li>
                                    <i className="icofont-ui-user"></i>{" "}
                                    {blog.author}
                                  </li>
                                </ul>
                              </div>

                              {/* SHORT DESCRIPTION */}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: blog.short_description,
                                }}
                              />

                              {/* FULL CONTENT */}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: blog.full_content,
                                }}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              )}
            </div>

            {/* ===== SIDEBAR ===== */}
            <div className="col-lg-4 col-12">
              <aside>
                <PopularPost />
              </aside>
            </div>

            {/* ===== MOBILE CSS FIX ===== */}
            <style>{`
              @media (max-width: 768px) {
                .post-thumbb {
                  margin-top: 40px;
                }
              }
            `}</style>

          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default BlogDetails;
